@if(displayScreen){    
	<div>
		<generic-loader></generic-loader>
		<app-header 
			[selectedHeader]="selectedHeader" 
			[profile]="profile" 
			[headerInputs]="headerInputs"
			[links]="links"
		>
		</app-header>

		<div style="background-color: #F6F6F6;">
			<router-outlet />
		</div>

		<div class="footer">
			<p>© Copyright {{currentYear}} Deloitte Development LLC. All rights reserved.</p>
			<ul>    
				<li><a href="https://deloittenet.deloitte.com/system/pages/Use.aspx" target="_blank">Terms of Use</a></li>
				<li><a href="https://deloittenet.deloitte.com/system/Pages/DeloitteNet_Web_Privacy_statement.aspx " target="_blank">Privacy</a></li>
				<li><a href="https://cookienotice.deloitte.com" target="_blank">Cookies</a></li>
				<li><a class="optanon-toggle-display">Cookie&nbsp;Settings</a></li>
			</ul>
		</div>

		<!-- Session Timeout Dialog -->
		<kendo-dialog 
		  *ngIf="sessionTimeoutDialogOpened"
		  title="Session Timed Out"
		  [minWidth]="350"
		  [width]="450"
		  (close)="onLogout()">
		  <p style="margin: 20px 0;">Your session has been timed out. Click OK to redirect. Please login back to the application in a new window.</p>
		  <kendo-dialog-actions layout="end" style="padding: 10px;">
		    <button kendoButton (click)="onLogout()" themeColor="primary" style="cursor: pointer; padding: 0.25rem 0.75rem;">OK</button>
		  </kendo-dialog-actions>
		</kendo-dialog>
	</div>}